<template>
  <div>
    <button
      class="btn-tiled quaternary"
      style="margin-right: 1rem;"
      @click="$refs.fileInput.click()"
    >
      Upload New Image
    </button>
    <button
      v-if="uploadCoverImage && !selectedCoverImage"
      class="btn-tiled quaternary"
      @click="onUpload"
    >
      Upload
    </button>
    <button
      class="btn-tiled primary"
      @click="isServerSelectHidden = false"
    >
      Select From Server
    </button>

    <ImageGallery
      v-if="!isServerSelectHidden"
      @imageUrl="setServerFile"
      @closeGallery="closeGallery"
    />
    <span v-if="uploadCoverImage">
      <p><b>Selected Image : </b> {{ uploadCoverImage.name }}</p>
    </span>
    <span v-if="selectedCoverImage">
      <br>
      <div
        class="img-wrap u-margin-top-medium u-center-horizontally"
        @click="resetCoverImage"
      >
        <span class="close">&times;</span>
        <img
          :src="selectedCoverImage"
          alt=""
        >
      </div>
    </span>
    <div />
    <input
      ref="fileInput"
      style="display: none"
      type="file"
      @change="onFileSelected"
    >
  </div>
</template>

<script>
import axios from 'axios'
import ImageGallery from './ImageGallery'

export default {
  components: {
    ImageGallery
  },
  props: {
    // type, required and default are optional, you can reduce it to 'options: Object'
    coverimage: { type: String, required: false, default: 'null' }
  },
  data () {
    return {
      blog: [],
      uploadCoverImage: null,
      selectedCoverImage: null,
      isServerSelectHidden: true
    }
  },
  watch: {
    selectedCoverImage: function () {
      this.$emit('coverImageSelected', this.selectedCoverImage)
    }
  },
  mounted () {
    console.log(this.coverimage)
    this.$nextTick(function () {
      this.coverimage ? console.log('cover image') : console.log('no cover image')
      this.coverimage ? this.selectedCoverImage = this.coverimage : this.selectedCoverImage = null
      console.log(this.selectedCoverImage)
    })
  },
  methods: {
    closeGallery () {
      this.isServerSelectHidden = true
    },
    setServerFile (value) {
      this.selectedCoverImage = value // someValue
    },
    resetCoverImage () {
      this.selectedCoverImage = null
      this.uploadCoverImage = null
    },
    getImageUrlViaResolution (fileName, resolution, bucketName) {
      const split = fileName.split('.')
      const filename = split[0]
      const extension = split[1]
      const bucket = bucketName || 'skypet_blog_images'
      const baseUrl = 'https://storage.googleapis.com/'
      let res = null
      if (!resolution) { res = '' }
      if (resolution === 1920) { res = '@s_1920' }
      if (resolution === 720) { res = '@s_720' }
      if (resolution === 100) { res = '@s_100' }
      const imageUrl = baseUrl + bucket + '/' + filename + res + '.' + extension
      return imageUrl
    },
    logBlog () {
      console.log(this.blog)
    },
    onFileSelected (event) {
      this.uploadCoverImage = event.target.files[0]
      this.onUpload()

    },
    onUpload () {
      console.log('hello')
      const fd = new FormData()
      fd.append('image', this.uploadCoverImage, this.uploadCoverImage.name)
      axios.post('https://us-central1-skypet-9792e.cloudfunctions.net/uploadFile', fd, {
        onUploadProgress: uploadEvent => {
          console.log('Upload Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 10) + '%')
        }
      })
        .then(res => {
          console.log(res)
          setTimeout(() => {
            this.selectedCoverImage = this.getImageUrlViaResolution(this.uploadCoverImage.name, 720)
          }, 5000)
        })
    }
  }
}
</script>

<style>
  .img-wrap {
  position: relative;
  display: inline-block;
  border: 1px red solid;
  font-size: 0;
}
.img-wrap .close {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 100;
  background-color: #FFF;
  padding: 5px 2px 2px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  opacity: .2;
  text-align: center;
  font-size: 22px;
  line-height: 10px;
  border-radius: 50%;
}
.img-wrap:hover .close {
  opacity: 1;
}
</style>
